import { render } from "./index.vue?vue&type=template&id=649a3618&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=649a3618&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649a3618"]])

export default __exports__